import {
	DeploymentSpecification,
	deploymentSpecificationSchema,
} from './deployment-specification.js'
import { BranchNameType } from '../types.js'
import * as z from 'zod'

export const remotePullRequestSchema = z.strictObject({
	sourceId: z.number(),
	spec: deploymentSpecificationSchema,
	intoBranchName: z.string(),
})

export type RemotePullRequest = z.infer<typeof remotePullRequestSchema>
